import { render, staticRenderFns } from "./BeLanguageModal.vue?vue&type=template&id=519549b5&scoped=true"
import script from "./BeLanguageModal.vue?vue&type=script&lang=js"
export * from "./BeLanguageModal.vue?vue&type=script&lang=js"
import style0 from "./BeLanguageModal.vue?vue&type=style&index=0&id=519549b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519549b5",
  null
  
)

export default component.exports